// extracted by mini-css-extract-plugin
export default {"root":"Table_root__LaA3f","sortable":"Table_sortable__StU+8","iconContainer":"Table_iconContainer__5udCe"};